import { rem } from 'polished';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const StyledText = styled.p`
  font-family: 'Nunito';
  font-size: ${rem('16px')};
  font-weight: 400;
  color: #eb5757;
  margin-left: 10px;

  @media (max-width: 575.98px) {
    font-size: ${rem('12px')};
  }
`;
